// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { roundToNearestMinutes as fn } from "../roundToNearestMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const roundToNearestMinutes = convertToFP(fn, 1);

// Fallback for modularized imports:
export default roundToNearestMinutes;
